import axios from "axios";

export default function SafetyemployeeDeleteService(safetyId) {
  return axios({
    method: 'delete',
    url: process.env.REACT_APP_API_HOST + "/safety/employee/" + safetyId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
